import dayjs from 'dayjs'
import { DaylightDateFormat } from '@/constants/DaylightDateFormat'

/**
 * Mock Issue Details Data
 * Matches the actual API response structure
 */
export const mockIssueDetails = {
  success: true,
  issueId: '6843177808',
  issue: {
    id: '6843177808',
    title: 'AxiosError: Network Error',
    culprit: '/linehaul/trips-dashboard/in-transit',
    status: 'unresolved',
    level: 'error',
    type: 'error',
    metadata: {
      title: 'AxiosError',
      value: 'Network Error',
      type: 'AxiosError',
      filename: 'axios/lib/core/Axios.js',
      function: 'handleError',
      in_app_frame_mix: 'system-only',
      sdk: {
        name: '@sentry/react',
        name_normalized: 'sentry.javascript.react',
      },
      initial_priority: 80,
    },
    numComments: 0,
    userCount: 5,
    count: 23,
    firstSeen: dayjs().subtract(3, 'months').toISOString(),
    lastSeen: dayjs().subtract(2, 'hours').toISOString(),
    permalink: 'https://sentry.io/organizations/daylight/issues/6843177808/',
    shortId: 'APEX-CLIENT-8FN',
    project: {
      id: '4507465295659008',
      name: 'apex-client',
      slug: 'apex-client',
      platform: 'javascript-react',
    },
    assignedTo: {
      id: 'user456',
      name: 'Jane Smith',
      email: 'jane.smith@example.com',
    },
    isBookmarked: false,
    isSubscribed: false,
    isUnhandled: true,
    hasSeen: false,
    annotations: [],
  },
  latestEvent: {
    eventId: 'abc123def456',
    dateCreated: dayjs().subtract(2, 'hours').toISOString(),
    environment: 'PROD',
    release: 'apex-client@1.2.3',
    transaction: '/linehaul/trips-dashboard/in-transit',
    traceId: 'trace-xyz-789-abc',
    browser: {
      name: 'Chrome',
      version: '120.0.0',
    },
    os: {
      name: 'Windows',
      version: '10',
    },
    exception: {
      type: 'AxiosError',
      value: 'Network Error',
      mechanism: {
        type: 'generic',
        handled: false,
      },
    },
    stackTrace: [
      {
        filename: 'axios/lib/core/Axios.js',
        function: 'handleError',
        lineNo: 123,
        colNo: 15,
        inApp: false,
      },
      {
        filename: 'axios/lib/adapters/xhr.js',
        function: 'createError',
        lineNo: 456,
        colNo: 20,
        inApp: false,
      },
      {
        filename: 'src/hooks/react-query/useSentryEvents.ts',
        function: 'queryFn',
        lineNo: 200,
        colNo: 10,
        inApp: true,
      },
      {
        filename: 'src/pages/SentryDashboard.tsx',
        function: 'Component',
        lineNo: 150,
        colNo: 5,
        inApp: true,
      },
    ],
    message: 'Network Error occurred while fetching Sentry events',
    tags: [
      {
        key: 'browser',
        value: 'Chrome 120.0.0',
        query: 'browser:"Chrome 120.0.0"',
      },
      { key: 'os', value: 'Windows 10', query: 'os:"Windows 10"' },
      { key: 'environment', value: 'PROD', query: 'environment:PROD' },
      { key: 'level', value: 'error', query: 'level:error' },
    ],
    user: {
      id: 'user789',
      email: 'user@example.com',
      username: 'testuser',
      ip_address: '192.168.1.100',
      name: 'Test User',
      geo: {
        country_code: 'US',
        city: 'San Francisco',
        region: 'CA',
      },
      data: null,
    },
    sdk: {
      name: '@sentry/react',
      version: '7.100.0',
    },
  },
  trend: {
    start: dayjs().subtract(7, 'days').unix(),
    end: dayjs().unix(),
    interval: 86400,
    data: [
      {
        timestamp: dayjs().subtract(6, 'days').unix(),
        date: dayjs().subtract(6, 'days').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 3 }],
      },
      {
        timestamp: dayjs().subtract(5, 'days').unix(),
        date: dayjs().subtract(5, 'days').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 2 }],
      },
      {
        timestamp: dayjs().subtract(4, 'days').unix(),
        date: dayjs().subtract(4, 'days').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 5 }],
      },
      {
        timestamp: dayjs().subtract(3, 'days').unix(),
        date: dayjs().subtract(3, 'days').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 4 }],
      },
      {
        timestamp: dayjs().subtract(2, 'days').unix(),
        date: dayjs().subtract(2, 'days').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 6 }],
      },
      {
        timestamp: dayjs().subtract(1, 'day').unix(),
        date: dayjs().subtract(1, 'day').format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 2 }],
      },
      {
        timestamp: dayjs().unix(),
        date: dayjs().format(DaylightDateFormat.ISO_DATE),
        count: [{ count: 1 }],
      },
    ],
  },
  timestamp: dayjs().toISOString(),
}
